"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const loyaltyvaluemarker = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 15 24",
    "aria-labelledby": (title ? `title-loyaltyvaluemarker` : '') + (description ? ` desc-loyaltyvaluemarker` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-loyaltyvaluemarker"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-loyaltyvaluemarker"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    id: "\uD83E\uDDECLoyalty-Module--",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "[HP/Loyalty/TierTracker]-States---Light-\uD83C\uDF15",
    transform: "translate(-319.000000, -2577.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M328.251081,2601 L328.251081,2598.03737 C331.532809,2597.46659 333.4,2595.12911 333.4,2592.62854 C333.4,2590.18233 331.900589,2588.06229 328.109627,2587.24689 L325.64833,2586.73046 C324.54499,2586.48584 323.979175,2585.91506 323.979175,2585.1812 C323.979175,2584.31144 324.771316,2583.4145 326.355599,2583.4145 C328.59057,2583.4145 329.071513,2584.82786 329.241257,2585.67044 L333.173674,2584.66478 C332.777603,2582.81653 331.363065,2580.66931 328.251081,2580.01699 L328.251081,2577 L324.997642,2577 L324.997642,2579.93545 C322.027112,2580.42469 319.650688,2582.51755 319.650688,2585.56172 C319.650688,2588.14383 321.60275,2589.99207 324.771316,2590.72593 L327.289194,2591.29672 C328.420825,2591.54134 329.043222,2592.05776 329.043222,2592.84598 C329.043222,2593.906 328.024754,2594.55832 326.610216,2594.55832 C324.17721,2594.55832 323.04558,2593.14496 322.904126,2591.56852 L319,2592.4111 C319.198035,2594.63986 321.008644,2597.46659 324.997642,2598.09173 L324.997642,2601 L328.251081,2601 Z",
    id: "dollar"
  }))));
};
var _default = exports.default = loyaltyvaluemarker;